import { render, staticRenderFns } from "./SubmissionFormClassroom.vue?vue&type=template&id=39933e11&scoped=true&"
import script from "./SubmissionFormClassroom.vue?vue&type=script&lang=js&"
export * from "./SubmissionFormClassroom.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionFormClassroom.vue?vue&type=style&index=0&id=39933e11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39933e11",
  null
  
)

export default component.exports